/**
 * Module 10: your first week with I2Q (1 minute). The player renders the certificate on
 * k1, the challenge (content/cheat-sheet.ts CHALLENGE) on k2 and the cheat sheet
 * (CHEAT_SHEET) on k3. These slides carry the text around them.
 */

import type { Module } from "@/features/training/types";

export const MODULE: Module = {
  id: "closing",
  title: "Your first week with I2Q",
  menuTitle: "First week",
  minutes: 1,
  kind: "closing",
  goals: [
    "Keep your certificate.",
    "Take the 5-day challenge.",
    "Print the cheat sheet for your desk.",
  ],
  helpTopics: ["work-faster", "contact"],
  slides: [
    {
      id: "k1",
      tone: "dark",
      title: "You finished the I2Q training.",
      job: "Print or save your certificate.",
      body: [
        {
          kind: "text",
          text: "Your certificate shows the course, your mail address, the date and your score. It prints on one A4 page.",
        },
      ],
      check: "Your manager can see that you finished. You do not need to send the certificate.",
    },
    {
      id: "k2",
      tone: "light",
      title: "Your 5-day challenge",
      job: "Tick one habit each day this week.",
      body: [
        {
          kind: "text",
          text: "Five small habits. They stop the most common mistakes. Your ticks stay in this browser.",
        },
      ],
      check: "One habit a day is enough.",
    },
    {
      id: "k3",
      tone: "grey",
      title: "Cheat sheet",
      job: "Print this page and keep it next to your screen.",
      body: [
        {
          kind: "text",
          text: "Ten jobs, where to find them in I2Q, and what to check. Press {key:?} on the queue or a case for all shortcuts.",
        },
      ],
      check: "Questions about a case? Use Give feedback, or ask your I2Q key user.",
    },
  ],
};
